exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.radio-group-full-width[data-v-5bff7bca] .v-input__control {\n  width: 100%\n}\n[data-v-5bff7bca] .v-list__tile{\n  height: 32px;\n}\n", ""]);

// exports
